<template>
<main class="c-home u-viewport-fit-h u-overflow-h u-bg--brand-dark is-first" @touchstart="onTouchDown" @touchmove="onTouchMove" @touchend="onTouchEnd" @DOMMouseScroll="onMouseWheel" @mousewheel="onMouseWheel">
     <app-home-slide  inline-template  data-color="clear" class="c-home__section o-wrapper--valign u-flex u-flex-ai--center u-flex-jc--center u-fit u-overflow-h u-bg--black"       :content="content"       :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="0"   :hasVideo="!1"  >
            <div class="o-wrapper--valign u-fit u-bg--white" >
              <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
               <<span class="c-home__section__chapter t-text--xxs t-text--base-bold u-absolute u-color--alpha-white u-hide@sm">{{'0'+(indexSS+1)}}</span>
               <img src="../../assets/medias/images/logo-simple-clear.svg" class="c-home__section__logo u-absolute u-pos-tl u-marg-t-lg u-marg-l-w1of12 u-zindex--3">
               <div class="o-wrapper--panel u-zindex--1 u-fit u-bg--black">
               <div class="c-home__section__poster__filter u-absolute u-pos-tl u-zindex--1 u-fit" style="background-color: rgb(134, 135,137);"> </div>
               </div>

               <div class="u-absolute u-pos-tl  u-marg-t-mdvh   u-marg-t-mdvh@sm  u-zindex--3 u-marg-l-w1of6s u-marg-l-w2of8@sm u-marg-l-w3of8@xsm" >
                 <div class="u-w2of2 u-fit-w@md">
                      <!--<img src="../../assets/medias/images/logo-simple-clear.svg" class="c-home__section__logo u-absolute u-pos-tl  u-zindex--3 ">-->
                     <div class="u-flex t-text--sm t-text--base-bold c-Home--title-lheigt ">

                          <span class="c-home__section__coverage__subsidtitleText  u-color--white">{{content.third_slide_subtitle}}</span>
                         </div>
                     </div>
               </div>

                <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none"></div>
                    <div class="c-home__section__fade u-relative u-zindex--3 u-flex u-flex-fd--column@md u-w9of12 u-w9of12@md u-fit-w@sm u-pad-x-w1of12@sm u-pad-x-w0of0@sm">
                          <div class="c-team__content u-marg-t-xxl  u-marg-t-xs@lg u-marg-t-xs@sm u-w2of2 u-w3of4@xsm u-marg-x-w1of12@sm u-w9of10@md  u-w9of10lg u-marg-t-xxl@sm" >
                              <section class="u-relative js-header-panel" data-color="clear">
                                <div class="c-team__section-container u-relative u-pad-y-ultra u-pad-r-w1of12 u-pad-y-xxl@md u-pad-y-lg@sm u-pad-x-w0of0@sm">
                                    <div class="c-team__section u-marg-t-lg u-marg-t-xl@lg u-marg-t-xs@sm">
                                          <div class="u-flex u-flex-fw--wrap u-flex-jc--space-between">
                                            <a class="c-team__link c-subsidiries__link t-link  u-marg-r-sub--wmax@xl u-marg-r-sub--wmin@sm u-marg-r-cov--wmax@lg u-marg-r-sub--wmax@fullHD u-marg-top-min--subsi@xsm"  href="javascript:void(0);"  v-for="(item, index)  in content.subsidiaries_sections[0].subsidiaries"  :data-index="index"  @click="item.first_name!=''?onOpenPopin(item,index):''"  @mouseenter="onHoverPopin((item.first_name + item.last_name).replace(/\s/g,''),index)" @mouseleave="onHoverOutPopin((item.first_name+item.last_name).replace(/\s/g,''),index)" >
                                                   <div class="c-team__link__photo-container js-photo-container u-relative o-box--14by10 u-marg-b-md u-overflow-h u-force-3d is-loading" >
                                                           <div class="u-absolute u-pos-t u-zindex--2"></div>
                                                           <img class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden fade-leave-to" :id="('hover'+item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium_large"     :alt="item.first_name + '  ' + item.last_name"   :title="item.first_name + '  ' + item.last_name"  @load="_onLoadMemberImage(index)"></img>
                                                           <img class="c-team__link__photo u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden" :id="(item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium"     :alt="item.first_name + '  ' + item.last_name"   :title="item.first_name + '  ' + item.last_name"  @load="_onLoadMemberImage(index)"></img>
                                                   </div>
                                                   <div class="u-pad-r-sm"></div>
                                            </a>
                                          </div>
                                    </div>
                                </div>
                              </section>
                          </div>
                    </div>

                    <app-team-board-popin :isActive="isBoardActive"  :content="content.subsidiaries_sections[0]" :index="0" ></app-team-board-popin>
                    <app-team-popin   :content="popinContent"  :title="popinTitle" :index="0"  :isActive="isPopinActive"  ></app-team-popin>


                  <div class="c-home__line-aside u-absolute u-bg--white" :style="stylesHeight1"></div>
                  <div class="c-home__line-aside c-home__line-aside--bottom u-absolute u-bg--white" :style="stylesHeight1"></div>
                  </div>
              </app-home-slide>



</main>
</template>

<script>
import appHomeSlide from '../app-home-slide/index.vue'
export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        },
        isPopinActive:
        {
          type:Boolean,
          default: !1
        }
    },
    components: {
        'app-home-slide':appHomeSlide
},
    mixins: [],
    data: function() {
        return {
            activeIndex: 0,
            activeRollOverIndex: 0,
            navHeight: 0,
            navOffsetTop: 0
        }
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.home
        },
        myStylesNavHeight() {
            return {
                height: this.navHeight+'px',
                width:'70px'
            }
        },
        myStylesTransform1() {
            return {
                transform: 'translateY('+100*this.activeRollOverIndex+') translateZ(0) ',

            }
        }
    },
    created: function() {

           this.PIXEL_STEP = 10,
            this.LINE_HEIGHT = 40,
            this.PAGE_HEIGHT = 800,
            this.NBSLIDE = 6,
            this._isWheeling = !1,
            this._isPointerDown = !1,
            this._pointerY = 0,
            this._pointerStartY = 0,
            this.eventHub.$on("resize", this.onResize),
                this.eventHub.$emit("hide:header")

    },
    destroyed: function()
    {
        this.eventHub.$off("resize", this.onResize)

    },
    mounted: function()
    {

            this.eventHub.$emit("page:ready"),
            this.$nav = this.$el.querySelector(".js-nav"),
            this.onResize()

    },
    methods:
    {
        _getFooter: function() {
            return this.adminContent.en["theme-general-settings"].footer_copyright_label.replace("<year>", (new Date).getFullYear())
        },
        onMouseWheel: function(t)
         {
           if(!this.isPopinActive)
           {
            var e = this;
            t.preventDefault(),
             t.stopPropagation(),
             clearTimeout(this.wheelTimer),
              this.wheelTimer = setTimeout(function() {  e._isWheeling = !1}, 500);

            if (Math.abs(-this.normalizeWheel(t).pixelY) < 10 && (clearTimeout(this.wheelTimer), this._isWheeling = !1), !(this._isWheeling || Math.abs(-this.normalizeWheel(t).pixelY) < 10 || Date.now() - this._lastWheelTime < 1e3)) {
                this._lastWheelTime = Date.now(),
                 this._wheelEndTimer = setTimeout(function() {clearTimeout(e.wheelTimer), e._isWheeling = !1  }, 1e3),
                 this._isWheeling = !0,
                 this._isScrollFromWheel = !0;
                var n = this.normalizeWheel(t),
                    r = -n.pixelY;

                //r < 0 ? this.onNextSlide() : r > 0 && this.onPrevSlide()
            }
          }
        },
        onResize: function()
        {
          this.debug&&console.log('On resize start method inside app-page-home');
            this.navHeight = 0,//this.$nav.offsetHeight,
            this.navOffsetTop = 0//this.$nav.offsetTop - .5 * this.navHeight
            this.debug&&console.log('On resize start method inside app-page-home End');
        },
        onPrevSlide: function()
        {
            this.activeIndex > 0 && (this.activeIndex -= 1, this.onChangeSlide())
        },
        onNextSlide: function()
        {
            this.activeIndex < this.NBSLIDE - 1 && (this.activeIndex += 1, this.onChangeSlide())
        },
        onDotClick: function(t)
        {
            this.activeIndex = t,
            this.onChangeSlide()
        },
        onDotOver: function(t)
        {
            this.activeRollOverIndex = t
        },
        onDotOut: function()
        {
            this.activeRollOverIndex = this.activeIndex
        },
        onMenuOver: function()
        {
            0 !== this.activeIndex && this.$el.classList.add("is-menu-hover")
        },
        onMenuOut: function()
        {
            this.$el.classList.remove("is-menu-hover")
        },
        onChangeSlide: function()
        {
            this.activeRollOverIndex = this.activeIndex,
                this.eventHub.$emit("change:slide", this.activeRollOverIndex),
                0 === this.activeIndex ? (this.$el.classList.add("is-first"),
                    this.eventHub.$emit("show:header")) : (this.$el.classList.remove("is-first"),
                    this.eventHub.$emit("hide:header"))
        },
        onTouchDown: function(t)
        {
          if(!this.isPopinActive)
          {
            this._isPointerDown = !0,
            this._pointerStartY = t.touches[0].clientY,
             this._pointerY = this._pointerStartY
           }
        },
        onTouchMove: function(t)
        {
          if(!this.isPopinActive)
          {
            this._isPointerDown && (t.preventDefault(),
             this._pointerY = t.touches[0].clientY)
           }
        },
        onTouchEnd: function(t)
        {
           //if(!this.isPopinActive)
           //{
            //this._isPointerDown && (this._isPointerDown = !1,Math.abs(this._pointerStartY - this._pointerY) > 10 && (this._pointerY > this._pointerStartY ? this.onPrevSlide() : this.onNextSlide()))
            //}
        },
        normalizeWheel: function(t)
        {
            return this._sX = 0,
             this._sY = 0,
              this._pX = 0,
              this._pY = 0,
              "detail" in t && (this._sY = t.detail),
               "wheelDelta" in t && (this._sY = -t.wheelDelta / 120),
               "wheelDeltaY" in t && (this._sY = -t.wheelDeltaY / 120),
               "wheelDeltaX" in t && (this._sX = -t.wheelDeltaX / 120),
                "axis" in t && t.axis === t.HORIZONTAL_AXIS && (this._sX = this._sY, this._sY = 0),
                this._pX = this._sX * this.PIXEL_STEP,
                this._pY = this._sY * this.PIXEL_STEP,
                "deltaY" in t && (this._pY = t.deltaY),
                "deltaX" in t && (this._pX = t.deltaX),
                (this._pX || this._pY) && t.deltaMode && (1 == t.deltaMode ? (this._pX *= this.LINE_HEIGHT, this._pY *= this.LINE_HEIGHT) : (this._pX *= this.PAGE_HEIGHT, this._pY *= this.PAGE_HEIGHT)),
                this._pX && !this._sX && (this._sX = this._pX < 1 ? -1 : 1),
                 this._pY && !this._sY && (this._sY = this._pY < 1 ? -1 : 1),
                 {
                spinX: this._sX,
                spinY: this._sY,
                pixelX: this._pX,
                pixelY: this._pY
            }
        }
    }
}

</script>
<style  scoped>

</style>



// WEBPACK FOOTER //
// src/components/app-page-subsidiaries/index.vue